import React from 'react';

// Shared between UploadDashboard.js's upload-history drawer and
// AssignedJobsSection.js's job drawer so the two never drift apart on what
// a given failed-check code means.
export const CHECK_LABELS = {
    'camera_avg_fps_within_0.5_of_target': { code: 'E-001', description: 'Camera avg FPS outside allowed range' },
    'camera_max_gap_below_69ms':           { code: 'E-002', description: 'Camera frame gap too large' },
    'camera_resolution_min_960x600':       { code: 'E-003', description: 'Camera resolution below 960x600' },
    'camera_resolution_by_slot':           { code: 'E-003', description: 'Camera resolution below required minimum (env/other: 960x600; left/right: 640x480)' },
    'camera_resolution_min_1280x720':      { code: 'E-003', description: 'Camera resolution below 1280x720 (legacy check)' },
    'camera_resolution_min_640x480':       { code: 'E-003', description: 'Camera resolution below 640x480 (legacy check)' },
    'camera_sync_below_34ms':              { code: 'E-004', description: 'Camera streams not synchronized' },
    'joint_camera_sync_below_34ms':        { code: 'E-005', description: 'Joint data not synced with camera frames' },
    'joint_avg_freq_above_45hz':           { code: 'E-006', description: 'Joint avg frequency too low' },
};
export const FALLBACK_ERROR_CODE = 'E-000';

// styles: the caller's own CSS module, needs epErrRow/epErrCode/epErrDesc.
export function getEpisodeRejectionRows(episode, styles) {
    if (episode?.status === 'QA_REJECTED' || episode?.stage === 'qa_rejected') return (
        <div className={styles.epErrDesc} style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}>
            <div>{episode.rejection?.reason || 'QA rejected'}</div>
            {episode.rejection?.rejected_at && <time dateTime={episode.rejection.rejected_at}>{new Date(episode.rejection.rejected_at).toLocaleString()}</time>}
        </div>
    );
    const processingError = episode?.processing_error || {};
    const details = processingError?.details || {};
    const failedChecks = Array.isArray(details.failed_checks) ? details.failed_checks.filter(Boolean) : [];

    if (failedChecks.length) {
        return failedChecks.map((k, i) => {
            const entry = CHECK_LABELS[k];
            const code = entry?.code || FALLBACK_ERROR_CODE;
            const desc = entry?.description || k;
            return (
                <div key={i} className={styles.epErrRow}>
                    <span className={styles.epErrCode}>{code}</span>
                    <span className={styles.epErrDesc}>{desc}</span>
                </div>
            );
        });
    }

    // Fallback: non-check errors
    let desc = 'Episode failed processing';
    if (processingError.step === 'mcap_validation') desc = 'MCAP validation failed';
    else if (processingError.error_message && processingError.error_message !== 'mcap validation failed') desc = processingError.error_message;
    return (
        <div className={styles.epErrRow}>
            <span className={styles.epErrCode}>{FALLBACK_ERROR_CODE}</span>
            <span className={styles.epErrDesc}>{desc}</span>
        </div>
    );
}
